import React from "react";
import "./styles.css";

/**
 * MenuTabs Component
 *
 * This component represents a menu tab item that can include text and an optional checkbox.
 *
 * @param {string} text - The text content of the menu tab.
 * @param {string} listType - The type of the menu tab, can be 'checkbox' or 'no' or undefined.
 */

const MenuTabs = ({ text, listType, onClick, style }) => {
  return (
    <div className="menu-item" onClick={onClick} style={style}>
      {listType === "checkbox" && <input type="checkbox" />}
      <div className="menu-item-text">{text}</div>
    </div>
  );
};

export default MenuTabs;
